import { render, staticRenderFns } from "./Vida.vue?vue&type=template&id=573acf6e&scoped=true"
import script from "./Vida.vue?vue&type=script&lang=js"
export * from "./Vida.vue?vue&type=script&lang=js"
import style0 from "./Vida.vue?vue&type=style&index=0&id=573acf6e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "573acf6e",
  null
  
)

export default component.exports